import React, { useEffect, useState } from 'react';
import MessageGrid from '../purchaseRequisition/messageGrid';
import ItemGridGRN from '../Goods&Receipt/grnList/itemGrid';
import AuthorizationGrn from '../Goods&Receipt/authorization';
import ApiService from '../../services/apiService';
import DirectPurchaseGrid from './directPurchaseGrid';
import Modal from 'react-bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import { FaAngleLeft } from "react-icons/fa6";
import moment from 'moment';
import DirectPurchaseViewGrid from './DPItemGridView';

const DirectPurchaseView = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const [usersDetails, setUser] = useState([]);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const [SupplierTab, setSupplierTab] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [OtherTab, setOtherTab] = useState(false);
    const [SelectedCurrency, setSelectedCurency] = useState([]);

    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [DPData, setDPData] = useState();
    const location = useLocation();
    const itmData = location.state;

    useEffect(() => {
        getApprovalUser()
        fetchPOData()
    }, [])
    const fetchPOData = async () => {
        let params = `?id=${itmData?.docno || itmData?.grnNo}`
        const grnlist = await apiService.getApiParamater("GET_GRN", params);
        // const selectedGRN = grnlist.data.result?.find(rec => rec?.grnNo === itmData?.docno || itmData?.grnNo)
        setDPData(grnlist.data.result[0])
    }
    const getApprovalUser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('DocNo', DPData?.grnNo || itmData?.docno);
            params.append('DocumentType', "GRN");
            let res = await apiService.get('GET_CURRENCY_MASTER')
            const filteredDenominations = res?.data?.result?.find(currency => currency?.isDefault === true);
            if (filteredDenominations) {
                setSelectedCurency({ label: filteredDenominations.code, value: filteredDenominations });
            }
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        console.log(data, 'reqData')
    };
    const handleRequisitionData = (data) => {
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        console.log(data, 'reqData')
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    return (
        <div className='px-4'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Direct Purchase</h5>
                <div className='d-flex gap-3'>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Purchase Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="GRNNO" className="form-label  pt-2 start">DP GRN No</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.grnNo}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">GRN Date</label>
                                <input className='form-Input w-70'
                                    type='date'
                                    value={DPData?.delivery_Date?.split('T')[0]}
                                    disabled
                                />
                            </div>
                            <div className='col center'>
                                <button className='mainbtn ' >Advance Search</button>
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceNo" className="form-label  pt-2 start">Invoice No</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.invoiceNo}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceDate" className="form-label  pt-2 start">Invoice Date</label>
                                <input
                                    type='date'
                                    className="form-Input w-70"
                                    value={DPData?.invoiceDate?.split('T')[0]}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="itemCode" className="form-label  pt-2 start">Item No</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.itemCode}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="TaxInvoice" className="form-label  pt-2 start">Tax Invoice No ( KRA )</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.batchNo}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="deliveryNote" className="form-label  pt-2 start">Delivery Note No</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.invoiceRef}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Item Description</label>
                                <input className='form-Input w-70'
                                    value={DPData?.itemDescription}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Delivery Type</label>
                                <input className='form-Input w-70'
                                    value={DPData?.delivery_Type}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Location" className="form-label  pt-2 start">Location</label>
                                <input className='form-Input w-70'
                                    value={DPData?.warehouse}
                                    disabled
                                />
                            </div>
                            <div className="col">
                                <div className="d-flex p-1 brderbox gap-2 justify-content-around " style={{ background: "#d9d9d95e" }}>
                                    <div className="form-check gap-3 center">
                                        <input style={{ width: "20px", height: "20px" }} disabled checked={DPData?.transporter === "Supplier" ? true : false}
                                            className="form-check-input" type="radio" name="flexRadioDefault" />
                                        <label className="form-check-label" for="Supplier">Supplier</label>
                                    </div>
                                    <div className="form-check gap-3 center" >
                                        <input className="form-check-input" style={{ width: "20px", height: "20px" }}
                                            type="radio" name="flexRadioDefault" checked={DPData?.transporter === "Cash" ? true : false} disabled
                                        />
                                        <label className="form-check-label" for="CashPurchase">Cash Purchase</label>
                                    </div>
                                    <div className="form-check gap-3 center" >
                                        <input className="form-check-input" style={{ width: "20px", height: "20px" }}
                                            type="radio" name="flexRadioDefault" checked={DPData?.transporter === "Sample" ? true : false} disabled
                                        />
                                        <label className="form-check-label" for="sample">sample</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="addCharges" className="form-label  pt-2 start">Add Charges</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.addCharges}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Supplier Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Supplier</label>
                                <input className='form-Input w-70'
                                    value={DPData?.vendorName}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Supplier ID</label>
                                <input className='form-Input w-70'
                                    value={DPData?.vendorId}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Currency" className="form-label  pt-2 start">Currency </label>
                                <input className='form-Input w-70'
                                    value={DPData?.currencyCode}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="ExchangeRate" className="form-label  pt-2 start">Exchange Rate </label>
                                <input className='form-Input w-70'
                                    value={DPData?.exchangeRate}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Property Group</label>
                                <input className='form-Input w-70'
                                    value={DPData?.costCenter1}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Property" className="form-label  pt-2 start">Property</label>
                                <input className='form-Input w-70'
                                    value={DPData?.costCenter2}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-2 start">Department</label>
                                <input className='form-Input w-70'
                                    value={DPData?.costCenter3}
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-2 start">Outlets</label>
                                <input className='form-Input w-70'
                                    value={DPData?.costCenter4}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setOtherTab(!OtherTab)}>
                    <div className="h6 pt-1">Other Details</div>
                </div>
                <div className={`slide-content ${OtherTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className='d-flex justify-content-between '>
                            <div className="d-flex justify-content-between col-md-4">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input
                                    className="form-Input w-70"
                                    value={DPData?.remarks}
                                    disabled
                                />
                            </div>
                            <div className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                            <div className="col-md-3 d-flex gap-2 justify-content-around">
                                <div className="form-check">
                                    <input
                                        style={{ width: "26px", height: "26px" }}
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={DPData?.vatInclusive === true ? false : true}
                                        disabled
                                    />
                                    <label className="form-check-label mx-2 mt-1">
                                        Vat Excluded
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>

                </div>
            </div>
            <div className="grid-1 brderbox2 p-2 mb-3">
                {gridVisibility[0] && (
                    <DirectPurchaseViewGrid itemData={DPData} onRequisitionData={handleRequisitionData} currencyPrecision={SelectedCurrency?.value?.precision}
                        selectedCheck={DPData?.vatInclusive} />
                )}
                {gridVisibility[1] && (
                    <AuthorizationGrn handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <MessageGrid handleMessage={handleMessage} />
                    </div>
                )}
                {gridVisibility[3] && (
                    <ItemGridGRN onRequisitionData={handleRequisitionData} />
                )}
            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={DPData?.GRNNO} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks}
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input
                                                    type="file" accept="image/*"
                                                    style={{ display: 'none' }}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                                <div>View</div></button></td>
                                            <td>
                                                <button disabled={!attachment.fileName} className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>

        </div >
    )
}

export default DirectPurchaseView